const prefix = 'BCZ-MALL'

const storage = {
  setItem: (key, value) => {
    const _key = storage.getPrefix(key)
    try {
      localStorage.setItem(_key, JSON.stringify(value))
    } catch (e) {
      console.log('保存失败 -----------')
    }
  },
  getItem: key => {
    try {
      const _key = storage.getPrefix(key)
      const value = JSON.parse(localStorage.getItem(_key))
      return value
    } catch (e) {
      console.log('读取失败 -----------')
    }
  },
  removeItem: key => {
    const _key = storage.getPrefix(key)
    localStorage.removeItem(storage.getPrefix(_key))
  },

  clear: () => {
    localStorage.clear()
  },
  getPrefix: key => {
    return `${prefix}-${key}`
  },
}
export default storage
